// extracted by mini-css-extract-plugin
export default {"list":"CollapsableList-module__list__Fy6Kp","button":"CollapsableList-module__button__yh54B"};